module.exports = __webpack_public_path__ + "static/media/contact_med.3ec7ed71.jpg";